export default class OperatorModel {
  /* tslint:disable:variable-name */
  public _id: string
  public operator_name: string
  public password: string
  public unit_id: string
  public access_right: number
  public created_at: Date
  public updated_at: Date

  constructor() {
    this._id = ''
    this.operator_name = ''
    this.password = ''
    this.unit_id = ''
    this.access_right = 1
    this.created_at = new Date()
    this.updated_at = new Date()
  }
}
